import React, { createContext, useContext, useState } from 'react';
import type { LanguageType } from '@op/types/common';

export interface IVideoTranslateContext {
  language: LanguageType;
  setLanguage: (lang: LanguageType) => void;
}

export const VideoTranslateContext = createContext<IVideoTranslateContext>({
  language: 'origin',
  setLanguage: () => {},
});

/**
 * Hook: 在任意 Tab 组件中获取/设置当前翻译语言
 */
export function useVideoTranslate() {
  return useContext(VideoTranslateContext);
}
